import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './index.css';

const index = () => {
    return (
        <div>
           <App />
        </div>
    )
}


ReactDOM.render(<App />, document.getElementById('root'));